import classNames from 'classnames';

export const ErrorIcon = ({ className }: { className?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            className={classNames('h-[20px] w-[20px] fill-error', className)}
        >
            <path d="M12.922 2.622c-.426-.83-1.418-.83-1.844 0l-8.91 17.354c-.454.88.067 2.024.921 2.024h17.822c.854 0 1.375-1.144.922-2.024l-8.91-17.354h-.001Zm-.915 2.88L19.5 20H4.502l7.505-14.498ZM10.5 17.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM11 14c0 .666.334 1 1 1 .667 0 1-.334 1-1v-4c0-.667-.333-1-1-1-.666 0-1 .333-1 1v4Z" />
        </svg>
    );
};
